// extracted by mini-css-extract-plugin
module.exports = {"image":"_7a3fb80146--image--vevZv","image-icon":"_7a3fb80146--image-icon--WnXMO"};